export default "__VITE_ASSET__Dx1r3DKw__"